import React from 'react'
import InputBox from '../../../common/InputBox'
import { currentFinancialYear } from '../../../../../lib/financialYear'

class Commission extends React.Component {
  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null

    this.props.onChange(this.props.type, {
      amount: amount,
      error: null
    })
  }

  handleFrequency = (frequency) => {
    this.props.onChange(this.props.type, { frequency: frequency })
  }

  handleAmountPreviousYear = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null
    this.props.onChange(this.props.type, { amountPreviousYear: amount })
  }

  handleFrequencyPreviousYear = (frequency) => {
    this.props.onChange(this.props.type, { frequencyPreviousYear: frequency })
  }

  render() {
    const {
      amount,
      frequency,
      amountPreviousYear,
      frequencyPreviousYear,
      errors,
    } = this.props

    return (
      <div>
        <InputBox
          label={ `Total commissions received in Financial Year ${currentFinancialYear().lastYear}` }
          labelClass='grey'
          type={ 'salaryAmount' }
          amount={ amount }
          frequency={ frequency }
          handleAmount={ this.handleAmount }
          handleFrequency={ this.handleFrequency }
          errorMessage={ errors && errors.amount }
          inputMode='numeric'
        />

        <InputBox
          label={ `Total commissions received in Financial Year ${currentFinancialYear().yearBeforeLast}` }
          labelClass='grey'
          type={ 'salaryAmountPreviousYear' }
          amount={ amountPreviousYear }
          errorMessage={ errors && errors.amountPreviousYear }
          frequency={ frequencyPreviousYear }
          handleAmount={ this.handleAmountPreviousYear }
          handleFrequency={ this.handleFrequencyPreviousYear }
          inputMode='numeric'
        />
      </div>
    )
  }
}

export default Commission
